var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fixed-box",class:_vm.classList},[_c('div',{staticClass:"fixed-box__close-button",on:{"click":_vm.close}},[_c('span',{staticClass:"icon icon--cross"})]),_c('ScPlaceholder',{attrs:{"name":"jss-sticky-box","rendering":_vm.rendering}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }